<div class="container-fluid homepage">
  <div class="row justify-content-center align-items-center vh-100">
    <div class="col-sm-12 col-md-8 col-lg-6">
      <div class="row justify-content-between mb-4">
        <div class="col-auto me-auto">
          <div>
            <a
              id="btn_to_techfinance"
              class="btn btn btn-outline-primary border-0"
              href="https://qa.techfinance.com.br/"
            >
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="currentColor"
              >
                <path
                  d="M21.0153 9.72843L13.5153 2.65218C13.5116 2.64898 13.5082 2.64554 13.505 2.64187C13.2289 2.39074 12.869 2.25159 12.4958 2.25159C12.1225 2.25159 11.7627 2.39074 11.4866 2.64187L11.4763 2.65218L3.98469 9.72843C3.83187 9.86895 3.70989 10.0397 3.62646 10.2298C3.54303 10.4199 3.49997 10.6252 3.5 10.8328V19.5C3.5 19.8978 3.65804 20.2793 3.93934 20.5607C4.22064 20.842 4.60218 21 5 21H9.5C9.89782 21 10.2794 20.842 10.5607 20.5607C10.842 20.2793 11 19.8978 11 19.5V15H14V19.5C14 19.8978 14.158 20.2793 14.4393 20.5607C14.7206 20.842 15.1022 21 15.5 21H20C20.3978 21 20.7794 20.842 21.0607 20.5607C21.342 20.2793 21.5 19.8978 21.5 19.5V10.8328C21.5 10.6252 21.457 10.4199 21.3735 10.2298C21.2901 10.0397 21.1681 9.86895 21.0153 9.72843ZM20 19.5H15.5V15C15.5 14.6022 15.342 14.2206 15.0607 13.9393C14.7794 13.658 14.3978 13.5 14 13.5H11C10.6022 13.5 10.2206 13.658 9.93934 13.9393C9.65804 14.2206 9.5 14.6022 9.5 15V19.5H5V10.8328L5.01031 10.8234L12.5 3.74999L19.9906 10.8216L20.0009 10.8309L20 19.5Z"
                  fill="currentColor"
                />
              </svg>
              <span class="ms-2 fw-bolder">Início TF</span>
            </a>
          </div>
        </div>
        <div class="col-auto">
          <div>
            <button
              id="btn_to_techfinance"
              class="btn btn btn-outline-primary border-0"
              data-bs-toggle="modal"
              data-bs-target="#desconectarModal"
            >
              <span class="ms-2 me-2 fw-bolder">Desconectar</span>
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11 20.25C11 20.4489 10.921 20.6397 10.7803 20.7803C10.6397 20.921 10.4489 21 10.25 21H5C4.60218 21 4.22064 20.842 3.93934 20.5607C3.65804 20.2794 3.5 19.8978 3.5 19.5V4.5C3.5 4.10218 3.65804 3.72064 3.93934 3.43934C4.22064 3.15804 4.60218 3 5 3H10.25C10.4489 3 10.6397 3.07902 10.7803 3.21967C10.921 3.36032 11 3.55109 11 3.75C11 3.94891 10.921 4.13968 10.7803 4.28033C10.6397 4.42098 10.4489 4.5 10.25 4.5H5V19.5H10.25C10.4489 19.5 10.6397 19.579 10.7803 19.7197C10.921 19.8603 11 20.0511 11 20.25ZM21.2806 11.4694L17.5306 7.71937C17.3899 7.57864 17.199 7.49958 17 7.49958C16.801 7.49958 16.6101 7.57864 16.4694 7.71937C16.3286 7.86011 16.2496 8.05098 16.2496 8.25C16.2496 8.44902 16.3286 8.63989 16.4694 8.78063L18.9397 11.25H10.25C10.0511 11.25 9.86032 11.329 9.71967 11.4697C9.57902 11.6103 9.5 11.8011 9.5 12C9.5 12.1989 9.57902 12.3897 9.71967 12.5303C9.86032 12.671 10.0511 12.75 10.25 12.75H18.9397L16.4694 15.2194C16.3286 15.3601 16.2496 15.551 16.2496 15.75C16.2496 15.949 16.3286 16.1399 16.4694 16.2806C16.6101 16.4214 16.801 16.5004 17 16.5004C17.199 16.5004 17.3899 16.4214 17.5306 16.2806L21.2806 12.5306C21.3504 12.461 21.4057 12.3783 21.4434 12.2872C21.4812 12.1962 21.5006 12.0986 21.5006 12C21.5006 11.9014 21.4812 11.8038 21.4434 11.7128C21.4057 11.6217 21.3504 11.539 21.2806 11.4694Z"
                  fill="currentColor"
                />
              </svg>
            </button>
          </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="desconectarModal">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="container">
                <h1 class="modal-title fs-5 mt-4">
                  Desconectar da techfinance
                </h1>
                <div class="row mb-4 mt-4">
                  <div class="col-6 d-grid">
                    <button
                      type="button"
                      class="btn btn-outline-primary fw-semibold"
                      data-bs-dismiss="modal"
                    >
                      Cancelar
                    </button>
                  </div>
                  <div class="col-6 d-grid">
                    <button
                      id="btn_to_techfinance"
                      class="btn btn btn-success border-0"
                      data-bs-dismiss="modal"
                    >
                      <span class="ms-2 fw-semibold">Desconectar</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="row align-content-center justify-content-center m-lg-auto m-auto"
      >
        <!-- <img src="../../../assets/img/guia-logo.svg" class="col-4" /> -->
        <h1
          class="text-center fw-bold mt-4 d-flex gap-2 justify-content-center"
        >
          Bem vindo ao Guia,
          <h1 class="text-primary fw-bold">{{ wealthName}}!</h1>
        </h1>
      </div>

      <div
        class="bg-light rounded text-center py-5 border border-2 m-lg-auto m-auto w-75"
      >
        <h2 class="col-12 mb-1">Escolha sua forma de acesso</h2>
        <div class="row justify-content-center mt-4">
          <div class="mb-3 col-12">
            <a
              id="anchor_to_clients"
              class="btn btn-primary col-sm-12 col-md-8 shadow-sm"
              routerLink="inicio/clientes"
            >
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="currentColor"
              >
                <g clip-path="url(#clip0_1440_13059)">
                  <path
                    d="M11.4921 14.805C12.4973 14.1358 13.2605 13.1609 13.6687 12.0244C14.077 10.888 14.1087 9.6503 13.7591 8.49443C13.4095 7.33856 12.6973 6.32587 11.7276 5.60611C10.758 4.88635 9.5825 4.49774 8.37492 4.49774C7.16735 4.49774 5.99184 4.88635 5.02221 5.60611C4.05258 6.32587 3.34032 7.33856 2.99076 8.49443C2.6412 9.6503 2.67288 10.888 3.08114 12.0244C3.4894 13.1609 4.25255 14.1358 5.25774 14.805C3.43945 15.4752 1.88659 16.7153 0.830862 18.3403C0.775377 18.4228 0.736837 18.5155 0.717482 18.613C0.698127 18.7105 0.698344 18.8108 0.718119 18.9082C0.737895 19.0056 0.776835 19.0981 0.832676 19.1804C0.888516 19.2626 0.960144 19.3329 1.0434 19.3872C1.12665 19.4415 1.21986 19.4787 1.31762 19.4967C1.41538 19.5146 1.51573 19.513 1.61285 19.4918C1.70996 19.4706 1.8019 19.4304 1.88332 19.3734C1.96473 19.3164 2.03401 19.2437 2.08711 19.1597C2.7681 18.1123 3.69995 17.2516 4.79802 16.6558C5.8961 16.06 7.12562 15.7479 8.37492 15.7479C9.62423 15.7479 10.8538 16.06 11.9518 16.6558C13.0499 17.2516 13.9817 18.1123 14.6627 19.1597C14.7727 19.3232 14.9427 19.4368 15.1358 19.476C15.3289 19.5152 15.5297 19.4769 15.6947 19.3692C15.8598 19.2616 15.9758 19.0933 16.0178 18.9008C16.0598 18.7082 16.0243 18.5069 15.919 18.3403C14.8633 16.7153 13.3104 15.4752 11.4921 14.805ZM4.24992 10.125C4.24992 9.30918 4.49185 8.51165 4.94511 7.8333C5.39837 7.15494 6.04261 6.62623 6.79636 6.31402C7.5501 6.00181 8.3795 5.92012 9.17967 6.07929C9.97984 6.23845 10.7148 6.63132 11.2917 7.20821C11.8686 7.7851 12.2615 8.5201 12.4207 9.32028C12.5798 10.1204 12.4981 10.9498 12.1859 11.7036C11.8737 12.4573 11.345 13.1016 10.6667 13.5548C9.9883 14.0081 9.19077 14.25 8.37492 14.25C7.28129 14.2488 6.2328 13.8138 5.45948 13.0405C4.68616 12.2672 4.25117 11.2187 4.24992 10.125ZM23.9506 19.3781C23.784 19.4868 23.581 19.5248 23.3864 19.4838C23.1918 19.4429 23.0214 19.3263 22.9127 19.1597C22.2326 18.1117 21.3008 17.2506 20.2025 16.6551C19.1042 16.0595 17.8743 15.7484 16.6249 15.75C16.426 15.75 16.2352 15.671 16.0946 15.5304C15.9539 15.3897 15.8749 15.1989 15.8749 15C15.8749 14.8011 15.9539 14.6103 16.0946 14.4697C16.2352 14.329 16.426 14.25 16.6249 14.25C17.2324 14.2495 17.8322 14.1147 18.3816 13.8554C18.931 13.5962 19.4163 13.2188 19.8029 12.7502C20.1895 12.2816 20.4678 11.7334 20.618 11.1448C20.7682 10.5562 20.7865 9.94168 20.6716 9.34516C20.5568 8.74865 20.3116 8.18486 19.9536 7.69408C19.5956 7.20331 19.1337 6.79766 18.6007 6.50612C18.0678 6.21458 17.477 6.04435 16.8707 6.00759C16.2643 5.97082 15.6573 6.06844 15.0931 6.29346C15.001 6.33323 14.902 6.35416 14.8018 6.35501C14.7016 6.35585 14.6022 6.3366 14.5095 6.29839C14.4169 6.26018 14.3328 6.20379 14.2623 6.13254C14.1918 6.06129 14.1363 5.97664 14.0991 5.88358C14.0619 5.79052 14.0437 5.69094 14.0456 5.59073C14.0475 5.49052 14.0695 5.39171 14.1102 5.30014C14.151 5.20856 14.2097 5.12609 14.2828 5.05758C14.356 4.98907 14.4421 4.93592 14.5362 4.90127C15.8275 4.38626 17.2639 4.36773 18.5681 4.84925C19.8723 5.33077 20.952 6.27823 21.5989 7.50885C22.2458 8.73947 22.414 10.1661 22.0711 11.5134C21.7283 12.8607 20.8986 14.0333 19.7421 14.805C21.5604 15.4752 23.1133 16.7153 24.169 18.3403C24.2776 18.5069 24.3156 18.7099 24.2747 18.9045C24.2337 19.0991 24.1171 19.2695 23.9506 19.3781Z"
                    fill="currentColor"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1440_13059">
                    <rect
                      width="24"
                      height="24"
                      fill="currentColor"
                      transform="translate(0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <span class="fw-bolder ms-2">Acessar Estudo de Cliente</span>
            </a>
          </div>
          <hr class="w-75 mt-2" />
          <div class="col-sm-12 col-md-8">
            <a
              class="btn col-12 text-primary fw-bold"
              id="anchor_to_personal"
              routerLink="inicio/estudo-pessoal"
            >
              <span class="me-3">Acessar Estudo Pessoal</span>
              <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
                <path
                  d="M21.2806 12.5306L14.5306 19.2806C14.3899 19.4213 14.199 19.5004 14 19.5004C13.801 19.5004 13.6101 19.4213 13.4694 19.2806C13.3286 19.1399 13.2496 18.949 13.2496 18.75C13.2496 18.551 13.3286 18.3601 13.4694 18.2194L18.9397 12.75H4.25C4.05109 12.75 3.86032 12.671 3.71967 12.5303C3.57902 12.3897 3.5 12.1989 3.5 12C3.5 11.8011 3.57902 11.6103 3.71967 11.4697C3.86032 11.329 4.05109 11.25 4.25 11.25H18.9397L13.4694 5.78061C13.3286 5.63988 13.2496 5.44901 13.2496 5.24999C13.2496 5.05097 13.3286 4.8601 13.4694 4.71936C13.6101 4.57863 13.801 4.49957 14 4.49957C14.199 4.49957 14.3899 4.57863 14.5306 4.71936L21.2806 11.4694C21.3504 11.539 21.4057 11.6217 21.4434 11.7128C21.4812 11.8038 21.5006 11.9014 21.5006 12C21.5006 12.0986 21.4812 12.1961 21.4434 12.2872C21.4057 12.3782 21.3504 12.461 21.2806 12.5306Z"
                  fill="currentColor"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="modal fade" id="modalPersonalStudy">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header border-0">
          <button
            id="close_modal_personal"
            type="button"
            class="btn-close"
            data-bs-toggle="modal"
            data-bs-target="#modalCancelRegister"
          ></button>
        </div>
        <div class="modal-body text-center">
          <h4>Iniciar um estudo pessoal:</h4>
          <div>
            <a
              id="anchor_acess_personal"
              class="btn btn-primary col-12 mb-3"
              routerLink="/personal"
              data-bs-dismiss="modal"
            >
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="currentColor"
              >
                <path
                  d="M22.1488 19.875C20.7209 17.4065 18.5206 15.6365 15.9528 14.7975C17.223 14.0414 18.2098 12.8892 18.7618 11.5179C19.3137 10.1467 19.4003 8.63211 19.0082 7.20688C18.6161 5.78165 17.767 4.52454 16.5912 3.6286C15.4155 2.73266 13.9782 2.24744 12.5 2.24744C11.0218 2.24744 9.58451 2.73266 8.40878 3.6286C7.23306 4.52454 6.38394 5.78165 5.99183 7.20688C5.59971 8.63211 5.68629 10.1467 6.23825 11.5179C6.79021 12.8892 7.77704 14.0414 9.0472 14.7975C6.47938 15.6356 4.27907 17.4056 2.85126 19.875C2.7989 19.9604 2.76417 20.0554 2.74912 20.1544C2.73407 20.2534 2.739 20.3544 2.76363 20.4515C2.78825 20.5486 2.83207 20.6397 2.8925 20.7196C2.95293 20.7995 3.02874 20.8664 3.11547 20.9165C3.2022 20.9666 3.29808 20.9988 3.39745 21.0113C3.49683 21.0237 3.5977 21.0161 3.69409 20.989C3.79049 20.9618 3.88047 20.9156 3.95872 20.8531C4.03697 20.7906 4.1019 20.713 4.1497 20.625C5.91595 17.5725 9.03782 15.75 12.5 15.75C15.9622 15.75 19.0841 17.5725 20.8503 20.625C20.8981 20.713 20.9631 20.7906 21.0413 20.8531C21.1196 20.9156 21.2095 20.9618 21.3059 20.989C21.4023 21.0161 21.5032 21.0237 21.6026 21.0113C21.7019 20.9988 21.7978 20.9666 21.8845 20.9165C21.9713 20.8664 22.0471 20.7995 22.1075 20.7196C22.1679 20.6397 22.2118 20.5486 22.2364 20.4515C22.261 20.3544 22.266 20.2534 22.2509 20.1544C22.2358 20.0554 22.2011 19.9604 22.1488 19.875ZM7.25001 8.99999C7.25001 7.96164 7.55792 6.9466 8.13479 6.08324C8.71167 5.21989 9.53161 4.54698 10.4909 4.14962C11.4502 3.75226 12.5058 3.64829 13.5242 3.85086C14.5426 4.05344 15.4781 4.55345 16.2123 5.28768C16.9465 6.0219 17.4466 6.95736 17.6491 7.97576C17.8517 8.99416 17.7477 10.0498 17.3504 11.0091C16.953 11.9684 16.2801 12.7883 15.4168 13.3652C14.5534 13.9421 13.5384 14.25 12.5 14.25C11.1081 14.2485 9.77359 13.6949 8.78934 12.7107C7.8051 11.7264 7.2515 10.3919 7.25001 8.99999Z"
                  fill="currentColor"
                />
              </svg>

              <span>Acessar Estudo Pessoal Existente</span>
            </a>
            <a
              id="anchor_to_new_personal"
              class="btn btn-outline-success col-12"
              routerLink="/diagnosis"
              data-bs-dismiss="modal"
            >
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="currentColor"
              >
                <path
                  d="M21.5 12C21.5 12.1989 21.421 12.3897 21.2803 12.5303C21.1397 12.671 20.9489 12.75 20.75 12.75H13.25V20.25C13.25 20.4489 13.171 20.6397 13.0303 20.7803C12.8897 20.921 12.6989 21 12.5 21C12.3011 21 12.1103 20.921 11.9697 20.7803C11.829 20.6397 11.75 20.4489 11.75 20.25V12.75H4.25C4.05109 12.75 3.86032 12.671 3.71967 12.5303C3.57902 12.3897 3.5 12.1989 3.5 12C3.5 11.8011 3.57902 11.6103 3.71967 11.4697C3.86032 11.329 4.05109 11.25 4.25 11.25H11.75V3.75C11.75 3.55109 11.829 3.36032 11.9697 3.21967C12.1103 3.07902 12.3011 3 12.5 3C12.6989 3 12.8897 3.07902 13.0303 3.21967C13.171 3.36032 13.25 3.55109 13.25 3.75V11.25H20.75C20.9489 11.25 21.1397 11.329 21.2803 11.4697C21.421 11.6103 21.5 11.8011 21.5 12Z"
                  fill="currentColor"
                />
              </svg>

              <span>Iniciar Novo Estudo Pessoal</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div> -->
